import { render, staticRenderFns } from "./page-input.vue?vue&type=template&id=382c2763&scoped=true&"
import script from "./page-input.vue?vue&type=script&lang=js&"
export * from "./page-input.vue?vue&type=script&lang=js&"
import style0 from "./page-input.vue?vue&type=style&index=0&lang=css&"
import style1 from "./page-input.vue?vue&type=style&index=1&id=382c2763&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c2763",
  null
  
)

export default component.exports